import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-support-vtubers',
  templateUrl: './vtubers.component.html',
  styleUrls: ['./vtubers.component.scss']
})
export class SupportVtubersComponent implements OnInit {
  vtubers: any[];
  isLoaded: boolean = false;

  constructor(
    public auth: AuthService,
    private fns: AngularFireFunctions
  ) {}

  ngOnInit() {
    this.vtubers = []
    this.loadVtubers();
  }

  loadVtubers() {
    this.isLoaded = false
    this.vtubers = []
    this.auth.getVtubers().subscribe(res => {
      res.map((vtuber: any) => {
        this.vtubers.push({
          photoURL: vtuber.photoURL,
          displayName: vtuber.displayName,
          title: vtuber.profile.title,
          uid: vtuber.uid
        })
      })

      this.isLoaded = true
    })
  }
}
